module.exports = __webpack_public_path__ + "img/gj-btn.a2535cdf.png";